module.exports = __webpack_public_path__ + "img/baden-wuerttenberg.9acee93.webp";